export default __webpack_public_path__ + "static/media/presley.72dde632.png";